var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.9999 1.4762c-5.52502 0-10.000022 4.3697-10.000022 9.7647 0 4.3209 2.862502 7.9704 6.837502 9.2643.5.0854.6875-.2075.6875-.4639 0-.2319-.0125-1.0008-.0125-1.8186-2.5125.4516-3.1625-.5981-3.3625-1.1474-.1125-.2807-.6-1.1473-1.025-1.3793-.35-.183-.85-.6347-.0125-.6469.7875-.0122 1.35.708 1.5375 1.0009.9 1.4769 2.3375 1.0619 2.9125.8056.0875-.6347.35-1.0619.6375-1.306-2.225-.2441-4.55-1.0863-4.55-4.8213 0-1.06196.3875-1.94078 1.025-2.62431-.1-.24412-.45-1.245.1-2.58765 0 0 .8375-.25632 2.75 1.00088.8-.2197 1.65002-.32955 2.50002-.32955s1.7.10985 2.5.32955c1.9125-1.26941 2.75-1.00088 2.75-1.00088.55 1.34265.2 2.34353.1 2.58765.6375.68353 1.025 1.55014 1.025 2.62431 0 3.7472-2.3375 4.5772-4.5625 4.8213.3625.3051.675.891.675 1.8064 0 1.3061-.0125 2.3558-.0125 2.6853 0 .2564.1875.5615.6875.4639 1.9851-.6545 3.7101-1.9003 4.9322-3.5622s1.8797-3.6562 1.8803-5.7021c0-5.395-4.475-9.7647-10-9.7647z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.1c5fd03b51c09026901f6ce75afc1f08.svg";
export { ForwardRef as ReactComponent };